import React, { CSSProperties, ReactNode } from 'react';


interface PanelProps {
    title: string;
    titleAlign?: 'left' | 'center' | 'right';
    children: ReactNode;
};


export const Panel = ({ title, titleAlign = 'left', children }: PanelProps) => {

    const titleStyle: CSSProperties = {
        textAlign: titleAlign,
        fontWeight: 'bold',
        fontSize: '1em',
        margin: 0,
    };

    return (<>
        <div style={titleStyle}>{title}</div>
        <div>{children}</div>
    </>);
};
